import { Component } from "react";
import { withRouter } from "../../../../utils/withRouter";
import { connect } from "react-redux";
import Loader from "../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import { toastError, toastSuccess } from "../../../../utils/constants";
import { getStallDesignApprovalList_action, updateStallDesignApproval_action } from "../../../../actions/admin_module_action/manual_forms_admin_action/stallDesignApproval_action/stallDesignApproval_action";
import CommonModal from "../../../../utils/CommonModal";
import VendorDrawer from "../../../../common_components/vendor_module_drawer";

class StallDesignApproval extends Component {

    //Initialized Constructor 
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            CompanyName: "",
            StallDesignApplicationList: [],
            RoleID: sessionStorage.getItem("RoleIDSS"),
            isViewModalOpen: false,
            selectedComponent: null,
            selectedId: null,
        }
        this.getStallDesignAppliaction = this.getStallDesignAppliaction.bind(this)
        this.onCheckedAppliactions = this.onCheckedAppliactions.bind(this)
        this.onRemarkEnter = this.onRemarkEnter.bind(this)
        this.updateStallDesignApproval = this.updateStallDesignApproval.bind(this)
    }

    // On Component Load
    componentDidMount() {
        this.props.location.state != null && this.props.location.state.companyName != "" && this.getStallDesignAppliaction(this.props.location.state.companyName)

        this.setState({
            CompanyName: this.props.location.state != null && this.props.location.state.companyName ? this.props.location.state.companyName : '',
        })
    }

    // Get Exh Badges Appliactions
    getStallDesignAppliaction(companyname) {
        this.setState({ isLoading: true })
        this.props.getStallDesignApprovalList_action(companyname)
            .then((data) => {
                if (data.error != 1) {
                    console.log("getStallDesignAppliaction Data", data.data)
                    data.data.map((item) => {
                        item.isSelected = false;
                        item.isReadOnly = true;
                        item.Remarks = item.RejectReason;
                    })
                    this.setState({
                        StallDesignApplicationList: data.data,
                        isLoading: false
                    })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    // On Check Exh Badge Applications
    onCheckedAppliactions(e) {
        const { StallDesignApplicationList } = this.state
        var checked = e.target.checked
        var id = e.target.value

        StallDesignApplicationList.length > 0 && StallDesignApplicationList.map((data) => {
            if (checked) {
                if (id == data.StallDesignFormID) {
                    data.isSelected = true;
                    data.isReadOnly = false
                }
            } else {
                if (id == data.StallDesignFormID) {
                    data.isSelected = false;
                    data.isReadOnly = true
                }
            }
        })
        console.log("09000909090", StallDesignApplicationList)
        this.setState({})
    }

    /// On Remark Enter
    onRemarkEnter(e, id) {
        const { StallDesignApplicationList } = this.state
        var value = e.target.value
        var list = [...StallDesignApplicationList]
        console.log("0101010100101", id)
        list.length > 0 && list.map((data) => {
            if (data.StallDesignFormID == id) {
                data.Remarks = value
            }
        })
        this.setState({ StallDesignApplicationList: list })

    }

    // On View E-Directory
    // onViewClick(id) {
    //     const { CompanyName } = this.state
    //     this.props.navigate('/stallDesign', { state: { is_View: true, CompanyName: CompanyName } })
    // }

    onViewClick(ServiceName, id) {
        sessionStorage.setItem('ExhRegistrationIDSS', id.ExhRegistrationID)
        this.setState({
            isViewModalOpen: true,
            selectedComponent: ServiceName,
            selectedId: id,
        });
    }


    // On Update Visa Approval
    updateStallDesignApproval(e, key) {
        const { StallDesignApplicationList, CompanyName } = this.state
        var applicationList = StallDesignApplicationList.filter((item) => item.isSelected == true)
        var list
        // checked Application List data Preparing to store
        var list = []
        applicationList.map(data => {
            var mapData = {
                'StallDesignFormID': parseInt(data.StallDesignFormID),
                "Remark": data.Remarks
            }
            list.push(mapData)
        });
        const isCheckedRemark = list.every(item => item.Remark != '' && item.Remark != null)
        if (list.length > 0) {
            if (key == 2 ? isCheckedRemark : true) {
                this.setState({ isLoading: true })
                this.props.updateStallDesignApproval_action(key == 1 ? true : false, list, false)
                    .then((data) => {
                        if (data.error != 1) {
                            this.setState({ isLoading: false })
                            toastSuccess(`Booth Stall Form ${key == 1 ? 'Approval' : 'Disapproval'} Successfully!`)
                            setTimeout(() => {
                                this.getStallDesignAppliaction(CompanyName)
                            }, 1000);
                        } else {
                            this.setState({ isLoading: false })
                            toastError(data.msg)
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            } else {
                toastError("Please Enter Remark")
            }
        } else {
            toastError("Select Atleast One Application")
        }
    }

    onBackClick() {
        window.history.back()
    }

    shareStallDesignForm(e, key, StallDesignFormID, Remarks) {
        const { StallDesignApplicationList, CompanyName } = this.state
        var applicationList = StallDesignApplicationList.filter((item) => item.isSelected == true)
        var list
        // checked Application List data Preparing to store
        var list = []
        const mapData = {
            'StallDesignFormID': parseInt(StallDesignFormID),
            "Remark": Remarks
        }
        list.push(mapData)

        this.setState({ isLoading: true })
        this.props.updateStallDesignApproval_action(key == 1 ? true : false, list, true)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ isLoading: false })
                    toastSuccess(`Booth Design ${key == 1 ? 'Approval' : 'Disapproval'} Mail Shared Successfully!`)
                    setTimeout(() => {
                        this.getStallDesignAppliaction(CompanyName)
                    }, 1000);
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    render() {
        const { isLoading, StallDesignApplicationList, RoleID } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <HeaderWithLogo />
                {RoleID == 7 && <VendorDrawer />}
                {RoleID != 17 && RoleID != 7 && <AdminDrawer />}
                <div>
                    <>
                        <div className={RoleID != 17 ? "with-dr-container" : ""}>
                            <div className="main-container" >
                                <div className="row m-0">
                                    <div className="breadcrumb-scroll-fixed">
                                        <h6 className="mb-0 py-2 text-white">
                                            Booth Design Approval</h6>
                                    </div>
                                </div>
                            </div>
                            <div className="admin-top-space pt-2">
                                <div className="row mb-6 m-0">
                                    {/* <div className="col-lg-12 mt-2">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <label htmlFor="validationCustom03">Login Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                defaultValue="jindal rectifiers"
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <label htmlFor="validationCustom03">Badge Quota</label>
                                            <input type="text" className="form-control" />
                                        </div>
                                        <div className="col-md-4">
                                            <label htmlFor="validationCustom03">Balance Quota</label>
                                            <input type="text" className="form-control" />
                                        </div>
                                    </div>
                                </div> */}
                                    <div className="table-responsive">
                                        <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 ">
                                            <thead>
                                                <tr>
                                                    <th className="text-center">Sr.No</th>
                                                    <th className="text-center" >Select</th>
                                                    <th className="text-center">Company Name</th>
                                                    <th>Name</th>
                                                    <th className="text-center">Country</th>
                                                    <th className="text-center">Status</th>
                                                    <th>Remarks</th>
                                                    <th className="text-center">View/Share</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    StallDesignApplicationList.length > 0 && StallDesignApplicationList.map((data, index) => (
                                                        <tr key={data.StallDesignFormID}>
                                                            <td className="text-center">{index + 1}</td>
                                                            <td className="text-center">
                                                                <input type="checkbox"
                                                                    checked={data.isSelected} value={data.StallDesignFormID}
                                                                    disabled={data.StatusID == "Approved" || data.StatusID == "Disapproved"}
                                                                    onChange={(e) => this.onCheckedAppliactions(e)}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                {data.CompanyName}
                                                            </td>

                                                            <td>{data.Name}</td>
                                                            <td className="text-center">{data.Country}</td>
                                                            <td className="text-center">{data.StatusID}</td>
                                                            <td>
                                                                <form>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        style={{ height: 40 }}
                                                                        disabled={data.isReadOnly}
                                                                        value={data.Remarks}
                                                                        onChange={(e) => this.onRemarkEnter(e, data.StallDesignFormID)}
                                                                    />
                                                                </form>
                                                            </td>
                                                            <td className="text-center">
                                                                <i class="fa fa-eye text-primary"
                                                                    onClick={(e) => this.onViewClick("Stall design", data)}>
                                                                </i> &emsp;
                                                                {(data.StatusID == "Approved" || data.StatusID == "Disapproved") &&
                                                                    <i class="fa fa-share grid-icon text-primary"
                                                                        onClick={(e) => this.shareStallDesignForm(e, data.StatusID == "Approved" ? 1 : 2, data.StallDesignFormID, data.Remarks)}
                                                                        title="Share mail again"
                                                                    >
                                                                    </i>
                                                                }
                                                            </td>
                                                        </tr>
                                                    ))
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="main-container mt-2">
                                        <div className="mt-1 mb-4">
                                            {StallDesignApplicationList.every(data => data.StatusID != "Approved" && data.StatusID != "Disapproved") &&
                                                <>
                                                    <a
                                                        className="btn btn-aqua"
                                                        type="submit"
                                                        onClick={(e) => this.updateStallDesignApproval(e, 1)}
                                                    >
                                                        Approve
                                                    </a>
                                                    <a

                                                        className="btn btn-red m-1"
                                                        type="submit"
                                                        onClick={(e) => this.updateStallDesignApproval(e, 2)}
                                                    >
                                                        Reject
                                                    </a>
                                                </>}
                                            <a

                                                className="btn btn-gray m-1"
                                                type="submit"
                                                onClick={(e) => this.onBackClick()}
                                            >
                                                Back
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>



                    </>
                    <CommonModal
                        isOpen={this.state.isViewModalOpen}
                        componentName={this.state.selectedComponent}
                        componentProps={{
                            is_View: true,
                            FormID: this.state.selectedId,
                        }}
                        onClose={() => this.setState({ isViewModalOpen: false })}
                    />
                </div >

            </>
        )
    }
}
export default withRouter(connect(null, { getStallDesignApprovalList_action, updateStallDesignApproval_action })(StallDesignApproval))